<template>
  <div class="forget-the-password-page">
    <HomePageTop />
    <div class="forgetPsd">
      <div class="panel-inner">
        <div class="forTitle">
          <!-- 找回你的密码 -->
          <h1 class="fg">{{ $fanyi("找回你的密码") }}</h1>
        </div>

        <div class="checkMethods" v-if="step == 2">
          <div class="checkMethodsCon">
            <h1>{{ $fanyi("请选择认证方式") }}：</h1>
            <h2>
              {{
                $fanyi(
                  "为了保护您的账户，Rakumart希望验证您是试图恢复或更改密码的人",
                )
              }}
            </h2>
            <div
              class="checkMethodsOpt"
              role="button"
              tabindex="0"
              @click.prevent="
                approveType = 'email';
                next();
              "
              @keyup.enter.prevent="
                approveType = 'email';
                next();
              "
            >
              <img
                class="opt-icon opt-icon--mail"
                :src="require('@/assets/newImg/email.svg')"
                alt=""
              />
              <span>{{ $fanyi("电子邮箱") }}</span>
              <el-button
                class="uiBtn uiGreen2"
                @click.stop.prevent="
                  approveType = 'email';
                  next();
                "
              >
                {{ $fanyi("确定") }}
              </el-button>
            </div>
            <div
              class="checkMethodsOpt"
              role="button"
              tabindex="0"
              @click.prevent="
                approveType = 'mobile';
                next();
              "
              @keyup.enter.prevent="
                approveType = 'mobile';
                next();
              "
            >
              <img
                class="opt-icon"
                src="../../assets/newImg/mobile.svg"
                alt=""
              />
              <span>{{ $fanyi("手机号码") }}</span>
              <el-button
                class="uiBtn uiGreen2"
                @click.stop.prevent="
                  approveType = 'mobile';
                  next();
                "
              >
                {{ $fanyi("确定") }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="changePasswordBox" v-if="step >= 3">
          <div class="step-body">
            <div class="identityVerification" v-if="step == 3">
              <div class="name">
                {{
                  approveType == "mobile"
                    ? $fanyi("你的Rakumart账户的手机号码")
                    : $fanyi("电子邮件链接到您的帐户")
                }}
              </div>
              <div class="selinputBox">
                <div class="field-block">
                  <div class="field-label">
                    {{
                      approveType == "mobile"
                        ? $fanyi("你的Rakumart账户的手机号码")
                        : $fanyi("电子邮件链接到您的帐户")
                    }}
                  </div>
                  <div class="field-row">
                    <el-select
                      v-if="approveType == 'mobile'"
                      class="country-select"
                      v-model="country"
                      filterable
                    >
                      <el-option
                        v-for="(item, index) in $imdata.countryAndAreaCode"
                        :key="index"
                        :label="item.value"
                        :value="item.value"
                      />
                    </el-select>
                    <div class="input-wrap" :class="{ succ: onumber }">
                      <el-input
                        v-model="onumber"
                        class="uiInput main-input"
                        :placeholder="
                          approveType == 'mobile'
                            ? $fanyi('请输入手机号')
                            : $fanyi('请输入邮箱')
                        "
                      />
                      <span class="gou" aria-hidden="true">✔</span>
                    </div>
                  </div>
                </div>
                <div class="field-block">
                  <div class="field-label">{{ $fanyi("验证码") }}</div>
                  <div class="field-row field-row--code">
                    <div
                      class="input-wrap"
                      :class="{ succ: yanZhengMaZhengQue }"
                    >
                      <el-input
                        v-model="regCode"
                        class="uiInput main-input"
                        :placeholder="$fanyi('输入验证码')"
                        @blur="checkVerificationCode()"
                      />
                      <span class="gou" aria-hidden="true">✔</span>
                    </div>
                    <el-button
                      v-if="showBtn"
                      class="uiBtn uiGreen code-btn"
                      @click.prevent="sendVerificationCode"
                    >
                      {{ $fanyi("获得代码") }}
                    </el-button>
                    <el-button
                      v-else
                      class="uiBtn uiGreen code-btn code-btn--wait"
                      disabled
                    >
                      {{ Countdown }} S
                    </el-button>
                  </div>
                </div>
                <el-button
                  class="uiBtn uiGreen next-full"
                  @click.prevent="next()"
                >
                  {{ $fanyi("下一步") }}
                </el-button>
              </div>
            </div>

            <div class="identityVerification" v-if="step == 4">
              <div class="name">{{ $fanyi("新密码") }}</div>
              <div class="selinputBox">
                <el-form
                  ref="formRef"
                  :rules="formRules"
                  :model="newPassword"
                  label-position="top"
                  class="pwd-form"
                >
                  <el-form-item
                    :label="$fanyi('新密码') + '：'"
                    prop="one"
                    class="regerror"
                  >
                    <el-input
                      v-model="newPassword.one"
                      show-password
                      class="uiInput main-input"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$fanyi('再次确认密码') + '：'"
                    prop="two"
                  >
                    <el-input
                      v-model="newPassword.two"
                      show-password
                      class="uiInput main-input"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      class="uiBtn uiGreen next-full"
                      @click.prevent="next()"
                    >
                      {{ $fanyi("下一步") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>

            <div class="ChangeSuccess" v-if="step == 5">
              <div class="ChangeSuccessOpt">
                <p class="successImg">
                  <img :src="require('@/assets/newImg/omplete.svg')" alt="" />
                </p>
                <p class="messageBox">
                  <span>{{ $fanyi("密码修改成功") }}</span>
                </p>
                <p class="messaeSpan">
                  <span>{{ $fanyi("您已经有了新密码，请重新登录。") }}</span>
                </p>
                <el-button
                  class="uiBtn uiGreen next-full"
                  @click.prevent="
                    $router
                      .push('/')
                      .then(() => $store.commit('getshowLoginDialog', true))
                  "
                >
                  {{ $fanyi("登录") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomePageTop from "../../components/head/HomePageTop.vue";

export default {
  name: "Reimposta-password",
  components: { HomePageTop },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fanyi("请再次输入密码")));
      } else if (value !== this.newPassword.one) {
        callback(new Error(this.$fanyi("您输入的密码不一致！")));
      } else {
        callback();
      }
    };
    return {
      step: 2,
      login_name: "",
      approveType: "mobile",
      showBtn: true,
      Countdown: 60,
      regCode: "",
      regNext: false,
      yanZhengMaZhengQue: false,
      country: "+39", // 手机认证时的国际区号，默认意大利 +39
      onumber: "",
      tiShi: "",
      numberTishiTwo: "",
      numberTishi: "",
      codeTimer: null,
      newPassword: {
        one: "",
        two: "",
      },
      formRules: {
        one: [
          {
            required: true,
            pattern: /^.{6,}$/,
            message: this.$fanyi("密码至少6位。"),
          },
        ],
        two: [
          {
            required: true,
            validator: validatePass2,
          },
        ],
      },
    };
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    clearCodeTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
    },
    forgetPasswordReset() {
      let datas = {
        password: this.newPassword.one,
        login_name:
          this.approveType == "mobile" ? this.onumber.trim() : this.onumber,
        verification: {
          number: this.onumber,
          code: this.regCode,
        },
      };
      this.$api.forgetPasswordReset(datas).then((res) => {
        if (res.success == true) {
          this.step++;
        } else {
          this.numberTishi = res.msg;
          this.regNext = false;
        }
      });
    },
    checkVerificationCode(fn) {
      this.$api
        .checkVerificationCode({
          occasion: "forget",
          number: this.onumber,
          code: this.regCode,
        })
        .then((res) => {
          if (res.success == true) {
            this.yanZhengMaZhengQue = true;
            if (fn) {
              fn();
            }
          } else {
            this.yanZhengMaZhengQue = false;
            this.$message.warning(this.$fanyi("验证码错误"));
          }
        });
    },
    sendVerificationCode() {
      if (!this.onumber) {
        return this.$message(this.$fanyi("必填参数缺失"));
      }
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.approveType == "email" && !emailRegExp.test(this.onumber)) {
        return this.$message(this.$fanyi("请输入正确的邮箱地址"));
      }

      let datas = {
        occasion: "forget",
        tool: this.approveType,
        number: this.onumber,
      };
      if (this.approveType == "mobile") {
        datas.area_code = this.country;
      }
      this.clearCodeTimer();
      this.showBtn = false;
      this.Countdown = 60;
      this.$api.sendVerificationCode(datas).then((res) => {
        this.showBtn = true;
        if (res.code != 0) return this.$message.error(this.$fanyi(res.msg));
        this.showBtn = false;
        this.numberTishi = "";
        this.codeTimer = setInterval(() => {
          this.Countdown--;
          if (this.Countdown <= 0) {
            this.showBtn = true;
            this.Countdown = 60;
            this.clearCodeTimer();
          }
        }, 1000);
      });
    },

    next() {
      switch (this.step) {
        case 2:
          this.step++;
          break;
        case 3:
          if (!this.onumber || !this.regCode) {
            return this.$message(this.$fanyi("必填参数缺失"));
          }
          var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          if (this.approveType == "email" && !emailRegExp.test(this.onumber)) {
            return this.$message(this.$fanyi("请输入正确的邮箱地址"));
          }
          this.checkVerificationCode(() => {
            this.step++;
          });
          break;
        case 4:
          this.$refs.formRef.validate((valid) => {
            if (valid) {
              this.forgetPasswordReset();
            }
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/mixin.scss";

.forget-the-password-page {
  min-height: 100vh;
  background: #fafafa;
}

.forgetPsd {
  padding: 8px 16px 48px;
  background: #fafafa;

  .panel-inner {
    max-width: $pageWidth;
    margin: 0 auto;
    background: #ffffff;
    border: 1px solid #eaecf0;
    border-radius: 12px;
    overflow: hidden;

    .forTitle {
      border-bottom: 1px solid #eaecf0;
      padding: 20px 24px;
      text-align: left;
      .fg {
        display: inline-flex;
        align-items: center;
        min-height: 24px;
        margin: 0;
        border-left: 3px solid #009246;
        padding-left: 12px;
        font-size: 18px;
        font-weight: 600;
        color: #101828;
      }
    }
  }

  .checkMethods {
    padding: 32px 24px 56px;
    .checkMethodsCon {
      max-width: 480px;
      margin: 0 auto;
      h1 {
        margin-bottom: 8px;
        font-size: 18px;
        font-weight: 600;
        color: #101828;
        line-height: 26px;
      }
      h2 {
        font-size: 14px;
        color: #667085;
        line-height: 22px;
        margin-bottom: 24px;
      }
      .checkMethodsOpt {
        cursor: pointer;
        background: #ffffff;
        border: 1px solid #eaecf0;
        border-radius: 16px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        padding: 16px 16px 16px 20px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          border-color: rgba(0, 146, 70, 0.45);
          box-shadow: 0 4px 12px rgba(16, 24, 40, 0.06);
        }
        .opt-icon {
          width: 28px;
          height: 28px;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .opt-icon--mail {
          width: 26px;
          height: 22px;
        }
        span {
          flex: 1;
          font-size: 15px;
          font-weight: 500;
          color: #101828;
          line-height: 22px;
          margin-right: 12px;
        }
        .uiBtn {
          flex-shrink: 0;
          height: 40px;
          padding: 0 20px;
          border-radius: 8px;
        }
      }
    }
  }

  .changePasswordBox {
    padding: 32px 24px 56px;

    .step-body {
      max-width: 480px;
      margin: 0 auto;
    }

    .identityVerification {
      .name {
        font-size: 18px;
        font-weight: 600;
        color: #101828;
        line-height: 26px;
        margin-bottom: 24px;
      }

      .selinputBox {
        .field-block {
          margin-bottom: 24px;
        }
        .field-label {
          font-size: 14px;
          font-weight: 500;
          color: #344054;
          margin-bottom: 8px;
          line-height: 20px;
        }
        .field-row {
          display: flex;
          align-items: center;
          gap: 10px;
          &--code {
            align-items: flex-start;
          }
        }
        .country-select {
          flex-shrink: 0;
          width: 96px;
          /deep/ .el-input__inner {
            height: 40px;
            line-height: 40px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            color: #027a48;
            background: #f6fbf5;
            border: 1px solid #c6e7c9;
            padding-right: 28px;
          }
          /deep/ .el-input__suffix {
            right: 4px;
          }
          /deep/ .el-input.is-focus .el-input__inner {
            border-color: #99d9a8;
          }
        }
        .input-wrap {
          flex: 1;
          min-width: 0;
          position: relative;
          &.succ {
            /deep/ .el-input__inner {
              background: #f6fbf5;
              border-color: #99d9a8;
            }
            .gou {
              opacity: 1;
            }
          }
          .gou {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            font-weight: 700;
            color: #009246;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.15s ease;
          }
        }
        .main-input {
          width: 100%;
          /deep/ .el-input__inner {
            height: 40px;
            line-height: 40px;
            border-radius: 8px;
            font-size: 15px;
            border: 1px solid #d0d5dd;
            padding-right: 36px;
          }
        }
        .code-btn {
          flex-shrink: 0;
          height: 40px;
          padding: 0 18px;
          border-radius: 8px;
          font-size: 15px;
          line-height: 1;
          &--wait {
            opacity: 0.55;
          }
        }
        .next-full {
          width: 100%;
          height: 40px;
          margin-top: 8px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          line-height: 1;
        }
      }

      .pwd-form {
        /deep/ .el-form-item__label {
          float: none;
          display: block;
          text-align: left;
          padding: 0 0 8px;
          line-height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #344054;
        }
        /deep/ .el-form-item__content {
          margin-left: 0 !important;
        }
        /deep/ .el-form-item {
          margin-bottom: 20px;
        }
        /deep/ .el-form-item__error {
          padding-top: 4px;
        }
      }
    }

    .ChangeSuccess {
      .ChangeSuccessOpt {
        .successImg {
          text-align: center;
          margin: 24px 0 16px;
          img {
            width: 56px;
            height: 56px;
          }
        }
        .messageBox {
          text-align: center;
          margin-bottom: 12px;
          span {
            font-size: 18px;
            font-weight: 600;
            color: #101828;
            line-height: 26px;
          }
        }
        .messaeSpan {
          max-width: 320px;
          text-align: center;
          margin: 0 auto 28px;
          span {
            font-size: 15px;
            color: #667085;
            line-height: 24px;
          }
        }
        .next-full {
          width: 100%;
          height: 40px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          line-height: 1;
        }
      }
    }
  }
}
</style>
